import { render } from "./ManageFieldEditModal.vue?vue&type=template&id=4da632c0"
import script from "./ManageFieldEditModal.vue?vue&type=script&lang=js"
export * from "./ManageFieldEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__